import { Button } from "PFComponents/button";
import { Inline } from "PFComponents/containers";
import { Tooltip } from "PFComponents/tooltip";
import { useTranslation } from "react-i18next";

import { useCustomValuePreviewContext } from "../../context/custom_value_preview_context";
import css from "../../custom_value_preview.module.scss";

export type FooterProps = {
  allowEdit: boolean;
  isRemoveDisabled: boolean;
  isSaveDisabled: boolean;
  isSaveTooltipVisible: boolean;
  saveNewLabel?: string;
  showSaveButton?: boolean;
  onRemove: VoidFunction;
  onSave: VoidFunction;
  onSaveAndReopen?: VoidFunction;
  onClose: VoidFunction;
};

export const Footer = ({
  allowEdit,
  isRemoveDisabled,
  isSaveDisabled,
  isSaveTooltipVisible,
  saveNewLabel,
  showSaveButton = true,
  onRemove,
  onSave,
  onSaveAndReopen,
  onClose
}: FooterProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "customValueSidepanel" });
  const { t: tTranslation } = useTranslation();
  const { isNew, canRemove } = useCustomValuePreviewContext();

  // TODO: [SP-2290] Make sure that changes from SP-2562 are applied when related PR is merged
  return (
    <Inline>
      <Button
        kind="secondary"
        text={allowEdit ? tTranslation("cancel") : tTranslation("close")}
        onClick={onClose}
      />
      {allowEdit && (
        <>
          {!isNew && canRemove && (
            <Button
              kind="danger"
              disabled={isRemoveDisabled}
              text={tTranslation("remove")}
              onClick={onRemove}
            />
          )}
          {showSaveButton && (
            <Tooltip disabled={!isSaveTooltipVisible} content={t("saveDisabledTooltip")}>
              {({ ref, getReferenceProps }) => (
                <Inline ref={ref} {...getReferenceProps({ className: css.saveButtons })}>
                  {isNew && onSaveAndReopen && (
                    <Button
                      kind="secondary"
                      disabled={isSaveDisabled}
                      text={t("saveAndAddNew")}
                      onClick={onSaveAndReopen}
                    />
                  )}
                  <Button
                    kind="primary"
                    disabled={isSaveDisabled}
                    text={isNew ? saveNewLabel || tTranslation("save") : tTranslation("update")}
                    onClick={onSave}
                  />
                </Inline>
              )}
            </Tooltip>
          )}
        </>
      )}
    </Inline>
  );
};
